/**
 * @note This children component use self state, lifecycle and fetching data from store, please be careful for handling the state
 */

// React
import { useCallback } from 'react'

// Interfaces
import { ISharedCompetencyUnitListProps } from './interfaces'

// Components
import { BaseLabel, BaseEmpty } from 'components'
import { UnitCompetencyItem, Wrapper } from './components'

// Mobx
import { observer } from 'mobx-react'

// i18n
import { useTranslation } from 'react-i18next'

const SharedCompetencyUnitList = observer(({ competencyUnits, onRedirectToDetail }: ISharedCompetencyUnitListProps) => {
  // Hook
  const { t } = useTranslation()

  /**
   * @description Count summary
   *
   * @return {object} total of summary
   */
  const _countSummary = useCallback((): { competentTotal: number; incompetentTotal: number } => {
    return competencyUnits.length > 0
      ? {
          competentTotal: competencyUnits.filter(
            competencyUnit =>
              competencyUnit.finishedCompetency === competencyUnit.totalCompetency &&
              competencyUnit.incompetentSummary! === 0 &&
              competencyUnit.competentSummary! > 0,
          ).length,
          incompetentTotal: competencyUnits.filter(
            competencyUnit =>
              competencyUnit.finishedCompetency === competencyUnit.totalCompetency && competencyUnit.incompetentSummary! > 0,
          ).length,
        }
      : {
          competentTotal: 0,
          incompetentTotal: 0,
        }
  }, [competencyUnits])

  return (
    <>
      {competencyUnits.length > 0 ? (
        <>
          {/* Body */}
          <div className="pb-6">
            <Wrapper>
              {competencyUnits.map(competencyUnit => (
                <div key={competencyUnit.competencyUnitId} className="mb-4">
                  <UnitCompetencyItem
                    competencyUnit={competencyUnit}
                    onDetailClick={() => onRedirectToDetail(competencyUnit.competencyUnitId!)}
                  />
                </div>
              ))}
            </Wrapper>
          </div>

          {/* Information */}
          <div className="flex flex-col gap-3 mt-1 mb-6">
            <BaseLabel
              label={`${t('shared.assessment.selfAssessment.summaryUk')}: ${_countSummary().competentTotal} Kompeten, ${
                _countSummary().incompetentTotal
              } Belum Kompeten`}
              className="font-weight-400 font-16 leading-5"
            />
          </div>
        </>
      ) : (
        <BaseEmpty />
      )}
    </>
  )
})

export { SharedCompetencyUnitList }
